import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Box } from 'pcln-design-system';
var StyledOverlay = styled(Box).withConfig({
  displayName: "Overlay__StyledOverlay",
  componentId: "sc-rnjqh1-0"
})(["display:block;position:fixed;top:0;bottom:0;left:0;right:0;opacity:", ";z-index:", ";cursor:pointer;"], function (_ref) {
  var popoverOpen = _ref.popoverOpen,
    overlayOpacity = _ref.overlayOpacity;
  return popoverOpen ? overlayOpacity : 0;
}, function (_ref2) {
  var zIndex = _ref2.zIndex;
  return zIndex < 0 ? 0 : zIndex;
});
var Overlay = function Overlay(_ref3) {
  var className = _ref3.className,
    _ref3$popoverOpen = _ref3.popoverOpen,
    popoverOpen = _ref3$popoverOpen === void 0 ? true : _ref3$popoverOpen,
    handleClick = _ref3.handleClick,
    _ref3$overlayOpacity = _ref3.overlayOpacity,
    overlayOpacity = _ref3$overlayOpacity === void 0 ? 0 : _ref3$overlayOpacity,
    _ref3$zIndex = _ref3.zIndex,
    zIndex = _ref3$zIndex === void 0 ? 101 : _ref3$zIndex;
  return /*#__PURE__*/React.createElement(StyledOverlay, {
    className: className,
    "aria-hidden": "true",
    tabIndex: "-1",
    onClick: handleClick,
    popoverOpen: popoverOpen,
    overlayOpacity: overlayOpacity,
    zIndex: zIndex,
    color: "background.darkest",
    "data-testid": "__pcln-popover_Overlay"
  });
};
Overlay.propTypes = {
  className: PropTypes.string,
  popoverOpen: PropTypes.bool,
  handleClick: PropTypes.func,
  overlayOpacity: PropTypes.number,
  zIndex: PropTypes.number
};
export default Overlay;